import { Injectable } from '@angular/core';

export interface SubmissionRule {
  id: number;
  templateItem: string;
  condition: SubmissionRuleConditions;
  equation: string;
  action: SubmissionRuleActions;
  hasError: boolean;
  errorMessage?: string;
}

export interface SelectOption {
  id: string;
  text: string;
}

export interface ActionOption extends SelectOption {
  additional?: string;
}

export interface WorkingNode {
  ref?: string;
  label?: string;
  dynamicAdjustmentStatementItemType?: string;
  hasRollup?: boolean;
  rollupLabel?: string;
  children?: WorkingNode[];
}

export interface SaveSubmissionRule {
  templateItem: string;
  condition: SubmissionRuleConditions;
  equation: string;
  action: SubmissionRuleActions;
}

export interface SpreadingTemplateInfo {
  name: string;
  isDefault?: boolean;
  templateSubtype?: string;
  submissionRules: SaveSubmissionRule[];
}

export interface TemplateData {
  templateUuid: string;
  templateId: number;
  templateName: string;
  templateType: string;
  workingNodes: WorkingNode[];
  spreadingTemplate: SpreadingTemplateInfo;
  incomeStatementCommonSizeDenominatorOverrideRef: string;
  balanceSheetCommonSizeDenominatorOverrideRef: string;
}

export enum SubmissionRuleActions {
  HARD_STOP= "InsufficientHardStop",
  SOFT_STOP = "InsufficientSoftStop"
}

export enum SubmissionRuleConditions {
  EQUAL_TO = "EqualTo",
  NOT_EQUAL_TO = "NotEqualTo",
  GREATER_THAN = "GreaterThan",
  LESS_THAN = "LessThan",
  GREATER_THAN_OR_EQUAL_TO = "GreaterThanOrEqualTo",
  LESS_THAN_OR_EQUAL_TO = "LessThanOrEqualTo"
}

@Injectable({
  providedIn: 'root'
})
export class TemplateDataService {
  private templateData: TemplateData | null = null;

  setTemplateData(data: TemplateData): void {
    this.templateData = data;
  }

  getTemplateData(): TemplateData | null {
    return this.templateData;
  }

  clearTemplateData(): void {
    this.templateData = null;
  }

  updateTemplateData(data: Partial<TemplateData>): void {
    if (this.templateData) {
      this.templateData = { ...this.templateData, ...data };
    }
  }
}
